module.exports = __webpack_public_path__ + "img/doomed.1d49dc53.png";